import { useNavigate } from 'react-router-dom';
import { SAUDE_HERO_BG } from '../data';

const FRENTES = [
  'Incentivo Comercial',
  'Fidelização',
  'Canais de Venda',
  'Engajamento',
  'Performance',
  'Compliance & Gestão',
];

export default function SaudeHero() {
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden pb-16 pt-28 md:pb-24 md:pt-36 lg:pt-44">
      <div aria-hidden="true" className="absolute inset-0">
        <img
          src={SAUDE_HERO_BG}
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-background-50"></div>
      </div>

      <div className="relative mx-auto w-full max-w-[1240px] px-6">
        <div className="mx-auto max-w-4xl text-center">
          <span className="lp-fade-up inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-background-50 backdrop-blur-sm">
            <i className="ri-heart-pulse-line"></i>
            Incentivo e fidelização para o ecossistema de saúde
          </span>

          <h1 className="lp-fade-up lp-delay-1 mt-6 font-heading text-4xl font-bold leading-[1.06] tracking-[-0.02em] text-background-50 md:text-5xl lg:text-6xl">
            Incentivo e fidelização para o
            <br />
            ecossistema de <span className="text-accent-300">Saúde</span>
          </h1>

          <p className="lp-fade-up lp-delay-2 mx-auto mt-6 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
            Transforme vendas, relacionamento e performance em experiências que geram valor. A GetPoints conecta
            operadoras, administradoras, corretoras, parceiros e equipes comerciais em campanhas de incentivo
            mensuráveis, automatizadas e rastreáveis.
          </p>

          <div className="lp-fade-up lp-delay-3 mt-8 flex flex-wrap items-center justify-center gap-3">
            <button
              type="button"
              onClick={() => navigate('/solicitar-demo')}
              className="inline-flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
            >
              Agende uma demonstração
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
            <button
              type="button"
              onClick={() => {
                const el = document.querySelector('#credito');
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
              className="inline-flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full border-2 border-white/30 px-7 text-sm font-semibold text-background-50 transition-colors hover:bg-white/10"
            >
              <i className="ri-file-search-line text-lg"></i>
              Conhecer a discriminação de crédito
            </button>
          </div>

          <div className="lp-fade-up lp-delay-4 mt-10 flex flex-wrap items-center justify-center gap-2.5">
            {FRENTES.map((frente) => (
              <span
                key={frente}
                className="rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs font-medium text-background-50 backdrop-blur-sm"
              >
                {frente}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}